<div class="modal-header bg-light">
    <h5 class="modal-title">Nuevo destino para Aeroplanta: {{ this.nombreAeroplanta | uppercase }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismissAll()"></button>
</div>

<div class="modal-body">
    <form [formGroup]="destinoForm">

        <div class="mb-3 row col-md-12">
            <label class="col-form-label col-sm-5">Tipo de configuración: </label>
            <div class="col-sm-7">
                <div class="btn-group" role="group" aria-label="Basic radio toggle button group" (change)="onTipoConfiguracionChange($event.target.value)">
                    <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off"
                        [value]="TipoConfiguracion.Destino" checked>
                    <label class="btn btn-outline-primary" for="btnradio1">Destino</label>

                    <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off"
                        [value]="TipoConfiguracion.NroVuelo">
                    <label class="btn btn-outline-primary" for="btnradio2">Número de vuelo</label>
                </div>
            </div>
        </div>

        <div *ngIf="this.tipoConfiguracion == TipoConfiguracion.Destino" class="row">
            <div class="mb-3 row col-md-12">
            <label for="codigoFormControl" class="col-sm-5 col-form-label">*Código Destino:</label>
                <div class="col-sm-7">
                    <input  id="codigoFormControl" type="text" class="form-control" formControlName="codigoFormControl" placeholder="Codigo Destino"
                        [inputFormatter]="formatterAeropuerto" [resultFormatter]="formatterAeropuerto"
                        (change)="confirmAeropuerto()" (selectItem)="selectAeropuerto($event)" [ngbTypeahead]="searchAeropuerto" />
                    <div *ngIf="codigoFormControl?.invalid && codigoFormControl?.errors?.required && (codigoFormControl.dirty || codigoFormControl.touched)"
                        class="alert alert-danger">Requerido
                    </div>
                    <loading-text-spinner *ngIf="cargandoAeropuertos" message="Obteniendo aeropuertos..."
                        color="primary">
                    </loading-text-spinner>
                </div>
            </div>
        </div>

        <div *ngIf="this.tipoConfiguracion == TipoConfiguracion.NroVuelo" class="row">
            <div class="mb-3 row col-md-12">
            <label for="numeroVueloFormControl" class="col-sm-5 col-form-label">*Número de vuelo:</label>
                <div class="col-sm-7">
                    <input  id="numeroVueloFormControl" type="text" class="form-control" formControlName="numeroVueloFormControl"
                        placeholder="XY ####" ngbTooltip="Permite FFAA, SANI, PRIV, YPF, GOB, MANT." style="text-transform:uppercase"/>
                    <div *ngIf="numeroVueloFormControl?.invalid && numeroVueloFormControl?.errors?.required && (numeroVueloFormControl.dirty || numeroVueloFormControl.touched)"
                        class="alert alert-danger">Requerido
                    </div>
                    <div
                        *ngIf="numeroVueloFormControl?.invalid && numeroVueloFormControl?.errors?.flightNumber && (numeroVueloFormControl.dirty || numeroVueloFormControl.touched)"
                        class="alert alert-danger">El número de vuelo no tiene el formato correcto
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="mb-3 row col-md-12">
            <label for="diaDesdeFormControl" class="col-sm-5 col-form-label">*Día desde:</label>
                <div class="col-sm-7">
                    <input  id="diaDesdeFormControl" type="number" class="form-control" [min]="1" formControlName="diaDesdeFormControl"/>
                    <div *ngIf="diaDesdeFormControl.invalid && diaDesdeFormControl.errors.required && (diaDesdeFormControl.dirty || diaDesdeFormControl.touched)"
                        class="alert alert-danger">Requerido
                    </div>
                    <div *ngIf="diaDesdeFormControl?.invalid && diaDesdeFormControl?.errors?.min && (diaDesdeFormControl.dirty || diaDesdeFormControl.touched)"
                        class="alert alert-danger">Supero el mínimo de días permitido
                    </div>
                    <div *ngIf="diaDesdeFormControl?.invalid && diaDesdeFormControl?.errors?.max && (diaDesdeFormControl.dirty || diaDesdeFormControl.touched)"
                        class="alert alert-danger">Supero el máximo de días permitido
                    </div>
                </div>
            </div>
        </div>
      <div class="row">
        <div class="mb-3 row col-md-12">
          <label for="diaDesdeFormControl" class="col-sm-5 col-form-label">*Día hasta:</label>
          <div class="col-sm-7">
            <input  id="diaHastaFormControl" type="number" class="form-control" [min]="1" formControlName="diaHastaFormControl"/>
            <div *ngIf="diaHastaFormControl.invalid && diaHastaFormControl.errors.required && (diaHastaFormControl.dirty || diaHastaFormControl.touched)"
                 class="alert alert-danger">Requerido
            </div>
            <div *ngIf="diaHastaFormControl?.invalid && diaHastaFormControl?.errors?.min && (diaHastaFormControl.dirty || diaHastaFormControl.touched)"
                 class="alert alert-danger">Supero el mínimo de días permitido
            </div>
            <div *ngIf="diaHastaFormControl?.invalid && diaHastaFormControl?.errors?.max && (diaHastaFormControl.dirty || diaHastaFormControl.touched)"
                 class="alert alert-danger">Supero el máximo de días permitido
            </div>
          </div>
        </div>
      </div>
      <!-- Cuentas -->
        <div class="row">
            <div class="mb-3 row col-md-12">
                <label for="cuentaFormControl" class="col-sm-5 col-form-label">Cuenta:</label>
                <div class="col-sm-7">
                    <select class="form-select" formControlName="cuentaFormControl" id="cuentaFormControl">
                        <option [ngValue]="null" [selected]="false">Seleccione una Cuenta</option>
                        <option *ngFor="let c of this.cuentas" [value]="c.ctA_SGC">
                            {{c.ctA_SGC}}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="modal-footer d-flex justify-content-center">
            <button type="button" class="btn btn-primary" (click)="guardarDestinos()" [disabled]="guardandoDatos || destinoForm.invalid">
                <span *ngIf="!guardandoDatos">Guardar</span>
                <div *ngIf="guardandoDatos" class="d-flex align-items-center">
                    <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                    <span>Guardando...</span>
                </div>
            </button>
        </div>
    </form>
</div>
